import type { Connectivity, DisplayStatus } from '@/types/api'
import type { DisplaySort } from '../api'

export interface DisplaysSearch {
  search?: string
  location_id?: string
  group_id?: string
  tag_id?: string
  connectivity?: Connectivity
  has_warnings?: true
  status?: DisplayStatus
  sort?: DisplaySort
  /** Opens the "Add display" sheet (deep link from onboarding / dashboard). */
  add?: true
}

const SORTS: readonly DisplaySort[] = ['name', '-name', '-last_heartbeat_at', '-created_at']
const CONNECTIVITY: readonly Connectivity[] = ['online', 'offline', 'unknown']
const STATUSES: readonly DisplayStatus[] = ['pending', 'active', 'orphaned', 'archived']

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.length > 0 ? v : undefined)
const flag = (v: unknown): true | undefined => (v === true || v === 'true' || v === 1 || v === '1' ? true : undefined)

export function validateDisplaysSearch(s: Record<string, unknown>): DisplaysSearch {
  return {
    search: str(s.search),
    location_id: str(s.location_id),
    group_id: str(s.group_id),
    tag_id: str(s.tag_id),
    connectivity: CONNECTIVITY.includes(s.connectivity as Connectivity) ? (s.connectivity as Connectivity) : undefined,
    has_warnings: flag(s.has_warnings),
    status: STATUSES.includes(s.status as DisplayStatus) ? (s.status as DisplayStatus) : undefined,
    sort: SORTS.includes(s.sort as DisplaySort) ? (s.sort as DisplaySort) : undefined,
    add: flag(s.add),
  }
}

export function activeFilterCount(s: DisplaysSearch): number {
  return [s.search, s.location_id, s.group_id, s.tag_id, s.connectivity, s.has_warnings, s.status].filter(Boolean).length
}
